import { Component, OnInit } from "@angular/core";
import { ConfigService } from "@app/core/config.service";
import { WindowService } from "@app/core/window.service";
import { AnalyticsService } from "@app/core/analytics.service";

@Component({
  selector: "om-direct-signup-banner",
  templateUrl: "./full-width-centered-banner.component.html",
  styleUrls: ["./full-width-centered-banner.component.scss"],
})
export class DirectSignupBannerComponent implements OnInit {
  constructor(
    private analyticsService: AnalyticsService,
    private config: ConfigService,
    private windowService: WindowService
  ) {}

  text: string;
  cta: string;
  icon: null;

  ngOnInit() {
    this.text = "Register your spouse or dependents";
    this.cta = "Get Started";
  }

  ctaAction() {
    this.analyticsService.trackDirectSignupStarted().subscribe(() => {
      let directSignupPath = `${this.config.json.myoneServer}/enterprise/referrals/new`;
      this.windowService.redirect(directSignupPath);
    });
  }
}
